// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"0f184ac3","404":"25d30566","513":"72379622","787":"87b9fb41"}[chunkId] + ".chunk.js";
};